import { useMutation, useQuery } from "react-query";
import { API } from '../../utils/AxiosInstance';

export interface UserProfile {
    first_name: string,
    last_name: string,
    email: string,
    enrolled: boolean,
    has_error?: boolean
}

export const useProfile = (token: string) =>
    useQuery<UserProfile, Error>("profile", () =>
        API.get<UserProfile>(`/profile/enroll_user/${token}`)
            .then(({ data }) => data)
            .catch((_error) => Promise.reject(new Error("Error")))
        ,
        {
            staleTime: Infinity,
        }
    );

export const useUserEnrollMutation = () => 
    useMutation(
        ({
            token
        }: { token: string }) =>
            
            API.post<{[key: string]: string}>(`/profile/enroll_user/${token}`)
            .then(() => Promise.resolve("success"))
            .catch((_error) => Promise.reject(new Error("Error")))
    );
    